<template>
  <div class="apply-section" ref="self">
      <img :src="images.apply" @load="emitReady">
      <!-- TODO: 给这俩图片添加点动画吧 -->
      <div class="flow">
          <img :src="images.flow">
      </div>
      <div class="flow2">
          <img :src="images.flow2">
      </div>
      <Form v-if="$route.name !== 'Apply'"/>
  </div>
</template>

<script>
import images from '@/utils/images.js'
import active from './active.js'
import Form from './form.vue'
export default {
    name: 'Apply',
    mixins: [active],
    components: { Form },
    data () {
        return {
            images: images,
            index: 5
        }
    }
}
</script>

<style lang="scss" scoped>
    .apply-section {
        position: relative;
        font-size: 0;
        .flow {
            position: absolute;
            width: 100%;
            top: 364px;
            overflow-x: auto;
            img {
                width: 1641px; 
            }
        }
        .flow2 {
            position: absolute;
            width: 100%;
            top: 1444px;
            overflow-x: auto;
            img {
                width: 1802px;
            }
        }
    }
</style>